import React from 'react'

import { HiOutlineArrowTopRightOnSquare } from 'react-icons/hi2'

import { SLED_PORTAL_REQUEST_URL } from '@/constants/env'

const SledSourceRequestBanner: React.FC = () => {
  return (
    <a
      href={SLED_PORTAL_REQUEST_URL}
      target="_blank"
      rel="noreferrer"
      className="flex items-center justify-center w-full max-w-screen-3xl p-4 bg-accent-50 dark:bg-accent-900/20 border border-accent-200 dark:border-accent-800 rounded-md hover:bg-accent-100 dark:hover:bg-accent-900/30 transition-colors group"
    >
      <div className="flex items-center gap-2 text-center">
        <span className="text-sm font-medium text-accent-900 dark:text-accent-100">
          Missing a specific source? Click here to request more portals.
        </span>
        <HiOutlineArrowTopRightOnSquare className="h-4 w-4 text-accent-700 dark:text-accent-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
      </div>
    </a>
  )
}

export default SledSourceRequestBanner
